import Vue from "vue";
// import axios from "axios";
import Router from "vue-router";
import store from "./store";
import Home from "@/pages/authenticated/Dashboard";
import routes from "@/router/routes/index.js";
import PrivacyPolicy from "@/pages/PrivacyPolicy";
import PrivacyPolicyEdify from "@/pages/PrivacyPolicyEdify";
import Courses from "@/pages/authenticated/Courses";
import {
  isTrialCompanyAdmin,
  shouldShowOnboardingOnLogin
} from "@/utils/onboarding";

Vue.use(Router);

let router = new Router({
  routes: [
  {
      path: "/",
      name: "Courses",
      component: Courses,
      meta: {
        breadcrumb: [
          {
            text: "Dashboard",
            disabled: true,
            href: "/"
          }
        ],
        public: false,
        admin: false
      }
    },
    {
      path: "/privacy-policy",
      name: "Privacy Policy",
      component: PrivacyPolicy,
      meta: {
        breadcrumb: [
          {
            text: "Privacy Policy",
            disabled: false,
            href: "/privacy-policy"
          }
        ],
        public: false,
        admin: true
      }
    },
    {
      path: "/privacy-policy-edify",
      name: "Privacy Policy Edify",
      component: PrivacyPolicyEdify,
      meta: {
        breadcrumb: [
          {
            text: "Privacy Policy",
            disabled: false,
            href: "/privacy-policy-edify"
          }
        ],
        public: false,
        admin: true
      }
    }
  ].concat(routes)
});

let previousRoute = null;

router.beforeEach((to, from, next) => {
  // const authenticated = store.state.user.authenticated
  const authenticated = store.getters.isLoggedIn;

  const userIsAdmin = store.getters.admin;
  const userIsPartner = store.getters.partner;
  const userIsSuperAdmin = store.getters.superAdmin;
  const userIsTeamManager = store.getters.teamManager;
  const userIsAccountManager = store.getters.accountManager;
  const userIsInvoicingAdmin = store.getters.invoicingAdmin;

  const companyState = store.getters.companyState;

  const onlyLoggedOut = to.matched.some(record => record.meta.onlyLoggedOut);
  const isPublic = to.matched.some(record => record.meta.public);
  const onlyAdmin = to.matched.some(record => record.meta.admin);
  const onlySuperAdmin = to.matched.some(record => record.meta.superAdmin);
  const suspendedAccessible = to.matched.some(record => record.meta.suspendedAccessible);
  const onlyTeamManager = to.matched.some(record => record.meta.teamManager);
  const onlyInvoicingAdmin = to.matched.some(record => record.meta.invoicingAdmin);

  if (authenticated) {

    if (companyState == 4 || companyState == 2) {
      if ((userIsAdmin || userIsPartner) && !suspendedAccessible) {
        return next("/admin/finance");
      } else {
        return next();
      }
    } else {
      if(from.path == '/admin/password-reset' || from.path == '/password-reset'){
        return next();
      } else if (onlyLoggedOut) {
        return next("/");
      } else if (onlyAdmin && !userIsAdmin) {
        return next("/");
      } else if (onlySuperAdmin && !userIsSuperAdmin) {
        return next("/");
      } else if (onlyTeamManager && userIsTeamManager) {
        next();
      }
      else if (onlyInvoicingAdmin && userIsInvoicingAdmin) {
        next();
      }
      else {
        // (The tour-phase bounce that sent trial admins from "/" and
        // /admin/users to /welcome until the tour was taken is gone with the
        // launcher, 18 Sep 2026: the rule below, on "/" only, until the setup
        // wizard is finished, is the whole of it.)
        if (to.path === '/') {
          if (userIsSuperAdmin) return next('/super-admin/companies');
          if (userIsPartner || userIsAccountManager) return next('/partner/users');
          if (userIsAdmin) {
            // shouldShowOnboardingOnLogin is a bare localStorage check - on
            // its own it sent PAID admins (fresh browser = empty cache) to
            // the trial onboarding page. Trial admins only.
            return next(
              isTrialCompanyAdmin(store.getters) && shouldShowOnboardingOnLogin()
                ? "/welcome"
                : "/admin/users"
            );
          }
          if (userIsTeamManager) return next('/course-library');
          if (userIsInvoicingAdmin)return next('/invoicing-admin/companies');
          return next('/courses');
        }
        next();
      }
    }



  } else {
    if (!isPublic) {
      return next({
        path: "/login",
        query: { redirect: to.fullPath }
      });
    } else {
      next();
    }
  }
  if (from.name) {
      previousRoute = from;
    }
});
// Make it accessible globally
Vue.prototype.$getPreviousRoute = () => previousRoute;

export default router;
